module.exports = __webpack_public_path__ + "img/psstruck-nobg2.b5a6cd4c.png";